import { Button, HStack, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import { CheckCircle2, ChevronDown, XCircle } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { AssessmentOutcomeSchema } from '@duke-hq/svc-api-db/schemas/enums/AssessmentOutcome.schema';
import { iconSize } from '@duke-hq/ui/constants/scalable';
import type { SelectableOutcome } from './types';

export function OutcomeOverrideMenu({
  selectedOutcome,
  onSelect,
}: {
  selectedOutcome: SelectableOutcome;
  onSelect: (value: SelectableOutcome) => void;
}) {
  const isSatisfactory = selectedOutcome === AssessmentOutcomeSchema.enum.SATISFACTORY;

  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        variant="outline"
        size="md"
        w="100%"
        h="100%"
        bg="bg.surface"
        borderColor="border.default"
        color="fg.default"
        rightIcon={<ChevronDown size={iconSize.md} />}
        _hover={{ bg: 'bg.subtle' }}
        _active={{ bg: 'bg.subtle' }}
      >
        <HStack spacing={2} justify="center">
          <Icon as={isSatisfactory ? CheckCircle2 : XCircle} boxSize={iconSize.md} />
          <Text fontSize="sm" fontWeight="medium">
            {isSatisfactory ? (
              <Trans>Override: Satisfactory</Trans>
            ) : (
              <Trans>Requires revision</Trans>
            )}
          </Text>
        </HStack>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => onSelect(AssessmentOutcomeSchema.enum.NOT_YET_SATISFACTORY)}>
          <HStack spacing={2}>
            <Icon as={XCircle} color="fg.muted" boxSize={iconSize.md} />
            <Text>
              <Trans>Requires revision</Trans>
            </Text>
          </HStack>
        </MenuItem>
        <MenuItem onClick={() => onSelect(AssessmentOutcomeSchema.enum.SATISFACTORY)}>
          <HStack spacing={2}>
            <Icon as={CheckCircle2} color="fg.muted" boxSize={iconSize.md} />
            <Text>
              <Trans>Override: Satisfactory</Trans>
            </Text>
          </HStack>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
